import { Injectable } from '@angular/core';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { ContactMechanismPurposeTypes } from '../../party/model/contact-mechanism-purpose-types.model';

@Injectable({
    providedIn: 'root'
})
export class ContactMechanismPurposeEntityService extends EntityCollectionServiceBase<ContactMechanismPurposeTypes> {
    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory) {
        super('ContactMechanismPurpose', serviceElementsFactory);
    }
}
